/**
 * M7 S38 part 2: a story line on the Charter Board (the Settlement 50-A registry entry, Mission 4's lasting trace;
 * `story-link/missions/m4.ts settlementRegistryLine`). The storyLink feature binds the source, so the Board needs no
 * story wiring of its own; unbound (the sandbox, tests, no career) it shows nothing. Read when the Board renders.
 */
export interface RegistryNote {
  /** The whole line as shown ("Settlement 50-A: SEALED"). */
  text: string
}

export type RegistryNoteSource = () => RegistryNote | null

let source: RegistryNoteSource | null = null

/** Binds (or with null, unbinds) the story's registry line. */
export function setRegistryNoteSource(fn: RegistryNoteSource | null): void {
  source = fn
}

/** The registry line now, or null. */
export function registryNote(): RegistryNote | null {
  return source?.() ?? null
}
